import { useMutation } from '@tanstack/react-query';

import {
  type QuoteFile,
  useRequest,
  type QuoteFileCategory,
} from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

type UseUpdateQuoteFileVars = {
  category?: QuoteFileCategory;
  quoteId: number;
  uuid: string;
  promotedInId?: number | null;
};

export const useUpdateQuoteFile: MutationFunction<
  QuoteFile,
  UseUpdateQuoteFileVars
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(({ quoteId, uuid, ...body }) => {
    return request(`/quotes/${quoteId}/files/${uuid}/`, {
      init: {
        method: 'PATCH',
        body,
      },
    });
  }, queryOptions);
};
